import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col space-y-5" }
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Referrals ")
const _hoisted_4 = { class: "flex flex-row space-x-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Create new influencer")
const _hoisted_6 = { class: "col-span-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-6 py-4" }
const _hoisted_7 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Influencers ")
const _hoisted_9 = { class: "w-full flex flex-col py-3" }
const _hoisted_10 = { class: "col-span-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-6 py-4" }
const _hoisted_11 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Referred Users ")
const _hoisted_13 = { class: "w-full flex flex-col py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_button = _resolveComponent("roof-button")!
  const _component_roof_table = _resolveComponent("roof-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_roof_header_text, { size: "xl" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_roof_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateInfluencer()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_roof_header_text, { size: "lg" }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_roof_table, {
          tableStructure: _ctx.Logic.Users.InfluencerTableStructure,
          paginatedData: _ctx.Influencers,
          "table-date-source": _ctx.Logic.Users.InfluencerSource,
          "sub-page-route": '/financials/referrals/influencers/'
        }, null, 8, ["tableStructure", "paginatedData", "table-date-source"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_roof_header_text, { size: "lg" }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_roof_table, {
          tableStructure: _ctx.Logic.Users.ReferredUserTableStructure,
          paginatedData: _ctx.ReferredUsers,
          "table-date-source": _ctx.Logic.Users.ReferredUserSource,
          "sub-page-route": '/financials/referrals/referred-users/'
        }, null, 8, ["tableStructure", "paginatedData", "table-date-source"])
      ])
    ])
  ]))
}